import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

let tabLabel = (text: string, count: number | string, color: string) => (
  <Box className="flex items-center gap-1.5">
    <span>{text}</span>
    <Typography
      component="span"
      sx={{ fontSize: 'inherit', fontWeight: 600, color }}
    >
      ({count})
    </Typography>
  </Box>
)

export default tabLabel
